import type { App } from 'vue'
import type { Composer } from 'vue-i18n'
import type { AppLocale } from '~/types/vue-i18n'
import { createI18n } from 'vue-i18n'
import en from '~/languages/en.json'
import ptBr from '~/languages/pt-br.json'

export type { AppLocale } from '~/types/vue-i18n'

type MessageSchema = typeof en

const LOCALE_STORAGE_KEY = 'fm-locale'

/** Legacy game assets live on VITE_MAIN_URL, not the dashboard origin. */
function absoluteMainAsset(path: string): string {
  const main = String(import.meta.env.VITE_MAIN_URL || '').replace(/\/$/, '')
  return `${main}${path.startsWith('/') ? path : `/${path}`}`
}

const UNIT_FMCOIN_IMG = `<img src="${absoluteMainAsset('/includes/imagens/v3/icon-fmcoin.png')}" class="fm-coin-image" alt="FM Coin" />`
const UNIT_DINHEIRO_IMG = `<img src="${absoluteMainAsset('/includes/imagens/v3/icon-dv.png')}" class="dv-image" alt="DV" />`

function withUnitImages(messages: MessageSchema): MessageSchema {
  return {
    ...messages,
    UNIDADE_DINHEIRO_IMG: UNIT_DINHEIRO_IMG,
    UNIDADE_FMCOIN_IMG: UNIT_FMCOIN_IMG,
  }
}

function readStoredLocale(): AppLocale {
  if (typeof localStorage === 'undefined')
    return 'pt-BR'

  const stored = localStorage.getItem(LOCALE_STORAGE_KEY)
  if (stored === 'en' || stored === 'pt-BR')
    return stored

  return 'pt-BR'
}

const initialLocale = readStoredLocale()

export const i18n = createI18n<[MessageSchema], AppLocale>({
  fallbackLocale: 'pt-BR',
  legacy: false,
  locale: initialLocale,
  messages: {
    'en': withUnitImages(en),
    'pt-BR': withUnitImages(ptBr),
  },
})

function getComposer(): Composer {
  return i18n.global as unknown as Composer
}

export function getLocale(): AppLocale {
  return getComposer().locale.value as AppLocale
}

export function setLocale(locale: AppLocale) {
  getComposer().locale.value = locale
  if (typeof localStorage !== 'undefined')
    localStorage.setItem(LOCALE_STORAGE_KEY, locale)
}

export function installI18n(app: App) {
  app.use(i18n)
}
